import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import '../styles/BecomeaPartnerPlace.css';

const Aboutus = () => {
  const teamMembers = [
    {
      name: "Sefik Bayindir",
      title: "Head of Design",
      image: "/images/sefik.jpg",
    },
    {
      name: "Akin Nefesogullari",
      title: "President",
      image: "/images/akin.jpg",
    },
    {
      name: "Ali Guklukay",
      title: "CTO",
      image: "/images/ali.jpg",
    },
    {
      name: "Kyle Wong",
      title: "COO",
      image: "/images/kyle.jpg",
    },
    {
      name: "Emre Cakmakoglu",
      title: "Head of Engineering",
      image: "/images/emre.jpg",
    },
    {
      name: "Mert Ozyilmaz",
      title: "Head of Product",
      image: "/images/mert.jpg",
    },
    {
      name: "Konstantin Molokin",
      title: "CIO",
      image: "/images/Konstantin Mololkin.jpg",
    },
  ];

  const navigate = useNavigate();

  const handleNavigateToCareers = () => {
    navigate('/careers');
    window.scrollTo(0, 0); // Scroll to the top of the page
  };

  return (
    <>
      <div className="about-text">
        <h1>
          Our mission is to create safer<br /> communities and support local<br /> businesses
        </h1>
      </div>
      <div className="About-video-container">
        <video className="Aboutus-video" src="/vedio/food.mp4" autoPlay muted loop />
      </div>

      <div className="aboutus-section">
        <div className="about-image">
          <img src="/images/about-rider.jpg" alt="About" />
        </div>
        <div className="aboutus-text">
          <h1>Rides and beyond</h1>
          <p>
            Berymo is the most affordable rideshare service<br /> that transports you anywhere in your town with<br /> a flat fee. Pick your destination on the app and<br /> only pay a flat fee.
          </p>
        </div>
      </div>
      <div className="Aboutus-section">
        <div className="Aboutus-text">
          <h1>Driver</h1>
          <h4>
            As a driver, you will pick up riders from their<br /> current location and drop them off at their<br /> chosen destination. Berymo is the easiest way to<br /> make more, drive less and create more space for <br />your life.
          </h4>
        </div>
        <div className="about-image">
          <img src="/images/about-driver.jpg" alt="about" />
        </div>
      </div>
      <div className="aboutus-section">
        <div className="about-image">
          <img src="/images/about-places.jpg" alt="About" />
        </div>
        <div className="aboutus-text">
          <h1>Rides and beyond</h1>
          <p>
            Dinner with friends, lunch with coworkers, or<br /> brunch with family - Berymo Places can take you<br /> there, for free at anytime.
          </p>
        </div>
      </div>
      <div className="berymo-quote">
        <h1>
          Everyday, numerous people are affected by drunk<br />
          drivers. At Berymo Places, we are determined to<br />
          reduce this by providing a free rideshare service when<br />
          you need it the most
        </h1>
          {/* <h5>Sefik Bayindir, Berymo Head of Design</h5> */}
      </div>
{/* <div className="team-heading">
  <h5>Berymo Leadership</h5>
  <h3>Executive Team</h3>
  </div>
  <div className="team-section">
      {teamMembers.map((member, index) => (
        <div className="team-member" key={index}>
          <img src={member.image} alt={member.name} />
          <h4>{member.name}</h4>
          <p>{member.title}</p>
        </div>
      ))}
    </div> */}
      <div className="signup-section">
        <h1>Together, we can change the world</h1>
        <p>Together, we can change the way people safely navigate around their communities</p>
        <button className="ride" onClick={handleNavigateToCareers}>
          SEE OPEN ROLLS
        </button>
      </div>
    </>
  );
};

export default Aboutus;